import { Box, Checkbox, Radio, Text, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";

const Response = () => {
  const ResponseData = useSelector((state) => state.viewResponses.data);
  const questionBoxWidth = useBreakpointValue({ base: "100%", md: "60%" });
  console.log(ResponseData);
  return (
    <Box>
      <Text align={"center"} fontSize="40px" fontWeight={"bold"} pt="15px">
        {ResponseData.formTitle}
      </Text>

      <Box>
        <Text
          align={"center"}
          fontFamily={"Open Sans"}
          fontSize={"lg"}
          color={ResponseData.status === "UNFILLED" ? "red" : "green"}
          fontWeight={"bold"}
          pt="15px"
        >
          {ResponseData.status}
        </Text>
        <Box
          display={"flex"}
          flexDir="column"
          justifyContent={"center"}
          w={questionBoxWidth}
          m="auto"
          p={5}
        >
          {ResponseData.questions?.map((el, i) => {
            return (
              <Box
                key={i}
                mt="5"
                pl="15"
                p="8"
                rounded="xl"
                backgroundColor={"#faf3fe"}
                boxShadow={"xl"}
              >
                <Text fontSize="20px" lineHeight={8}>
                  {i + 1}. {"  "}
                  {el.questionText} ?{" "}
                </Text>
                {el.questionType == "MCQ" && (
                  <Box display={"flex"} flexWrap={"wrap"} gap="5">
                    {el.optionsStrings?.map((option, i) => {
                      {
                        if (ResponseData.status == "UNFILLED") {
                          return (
                            <Checkbox
                              size={"lg"}
                              ml={2}
                              mt="5"
                              key={i}
                            >
                              {option}
                            </Checkbox>
                          );
                        } else {
                          const isChecked = option === el.selectedOption;
                          return (
                            <Checkbox
                              size={"lg"}
                              mt="5"
                              isChecked={isChecked}
                              key={i}
                              isDisabled="true"
                            >
                              {option}
                            </Checkbox>
                          );
                        }
                      }
                    })}
                  </Box>
                )}
                {el.questionType == "YES_NO" && (
                  <Box display={"flex"} gap="5">
                    {el.optionsStrings?.map((option, i) => {
                      {
                        if (ResponseData.status == "UNFILLED") {
                          return (
                            <Radio
                              size={"lg"}
                              ml={3}
                              mt="5"
                              key={i}
                              value={option === el.selected}
                            >
                              {option}
                            </Radio>
                          );
                        } else {
                          const value = option === el.selectedOption;
                          return (
                            <Radio
                              size={"lg"}
                              mt="5"
                              value={value}
                              isChecked={value}
                              key={i}
                              isDisabled="true"
                            >
                              {option}
                            </Radio>
                          );
                        }
                      }
                    })}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Response;
